<header *ngIf="!showCropper">
  <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
  <app-generic-header *ngIf="this.userData?.interest2!=null" [goBack]=backPage.bind(this) variant="save"
    [title]="'profile'| translate"></app-generic-header>
</header>

<!-- `editor-cheio` tira o `ion-padding` e pinta o fundo escuro enquanto o editor esta
     aberto. O `<header>` ja era `*ngIf="!showCropper"`, entao em modo editor a tela fica
     inteira para a foto — e e dai que vem o ganho de area, nao de manter a foto fixa. -->
<ion-content [class.ion-padding]="!showCropper" [class.editor-cheio]="showCropper"
  [class.ipad-fix]="isIpad" [class.tablet-fix]="isTablet">

  <!-- Crop: sem header, so um botao de fechar flutuante (chama o mesmo back()). -->
  <ion-button *ngIf="showCropper" class="crop-close" (click)="back()" [attr.aria-label]="'close' | translate">
    <ion-icon slot="icon-only" name="close"></ion-icon>
  </ion-button>

  <div class="cover" *ngIf="!activeFocus">
    <br>
  </div>

  <div>
    <div class="frameDiv">
      <div class="mainDiv" [class.ipad-main-div]="isIpad" [class.tablet-main-div]="isTablet">
                <!-- `&& !showCropper` como o `box-photos` logo abaixo ja fazia: com o editor aberto
             estes dois textos nao tem papel nenhum e empurravam o palco da foto para baixo,
             furando a premissa de que ele comeca no topo da tela. Atingia justamente quem
             esta colocando a primeira foto. -->
        <h2 *ngIf="isFirstSetup && !showCropper" class="welcomeText">
          {{'welcomeToVeggly' | translate}}
        </h2>

        <p *ngIf="isFirstSetup && !showCropper" class="pleaseCompleteText">{{'pleaseCompleteYourProfile' | translate}}</p>

        <ion-row class="box-photos" *ngIf="!showCropper">
          <ion-col size="6">
            <div class="infoCategoryText photos">
              {{'myPictures' | translate}}
            </div>
          </ion-col>
        </ion-row>

        <!--Photo Grid-->
        <div class="boxes" [ngClass]="{'shuffling-active': shuffling}">
          <!-- Carga da foto. Cobre o intervalo entre escolher na galeria e o cropper estar
               desenhado — soma de `readAsBase64` com a decodificação da imagem. Antes esse
               intervalo era tela parada, sem nenhum sinal de que algo estava acontecendo. -->
          <div *ngIf="showCropper && aguardandoCropper" class="crop-loading">
            <ion-spinner name="crescent"></ion-spinner>
          </div>

          <div *ngIf="showCropper" class="cropper-host crop-stage">
            <div class="block-cropper" [style.--foto-filtro]="previewFilter">
              <angular-cropper #angularCropper [cropperOptions]="cropperOptions" [imageUrl]="myImage" (ready)="onCropperReady()"></angular-cropper>
            </div>
          </div>

          <!-- Photo grid: Sortable long-press delay starts reorder without releasing -->
          <div *ngIf="!showCropper" [nxtSortablejs]="pictures" [config]="sortablejsOptions">
            <div class="horizontalList" *ngFor="let picture of pictures; let i = index" [attr.data-id]="i">
              <div class="img-wrapper">
                <img
                  class="boxImg"
                  [ngClass]="{'shake': shuffling && (i !== 0 && userData?.userValidated || !userData?.userValidated)}"
                  [src]="picture"
                  (click)="!shuffling && presentActionSheet(i)"
                  (dragstart)="$event.preventDefault()"
                  draggable="false"
                />

                <div *ngIf="picture!==grayPlus" (click)="!shuffling && presentActionSheet(i)" class="close-circle">
                  <ion-icon name="close"></ion-icon>
                </div>

                <div *ngIf="picture!==grayPlus && i===0 && userData?.userValidated" class="logoUserValidated">
                  <ion-icon src="assets/imgs/new-check-img.svg" alt="Validated Imge"></ion-icon>
                </div>
              </div>
            </div>
          </div>

          <div class="saveOrder">
            <ion-button *ngIf="!showCropper && shuffling" shape="round" expand="full" (click)="saveOrder()">
              <ion-icon class="buttonIcon" name="reorder-four-outline"></ion-icon>
              {{('saveOrder') | translate}}
            </ion-button>
          </div>

        </div>

        <div class="pictureTip" *ngIf="!showCropper">
          {{'pressHoldToReorder' | translate}}
        </div>

        <div id="userInfoContainer" *ngIf="!showCropper">
          <div class="abouteMe" [class.expanded]="aboutMeExpanded" (click)="toggleAboutMeExpansion($event)">
            <span class="infoCategoryText">{{'aboutMe' | translate}}</span>

            <ion-list lines="none">

              <ion-item>
                <ion-textarea (ionChange)="setChanged()" (ionFocus)="expandAboutMe()" [(ngModel)]="aboutData" lines="none"
                  class="selectText" [autoGrow]="true"></ion-textarea>
              </ion-item>

              <ion-item>
                <div class="charsRemaining">
                  <span class="charsLeft{{getCharStatus()}}">{{getCharsLeft()}} {{'left' | translate}}</span>
                </div>
              </ion-item>
            </ion-list>

          </div>
          <span class="infoCategoryText">{{'aboutMe' | translate}}</span>
          <!---Avocai Club Indicator-->
          <div [ngStyle]="(!userIsPremium ? {'cursor': 'pointer'} : null)"
            (click)="!userIsPremium && goToAvocadoClubIndicator()" class="avocadoButton">

            <div class="avocadoText">
              <img class="avocado" src="assets/imgs/fyraplus.svg">
              {{'showAvocadoClubInProfile' | translate}}

            </div>

            <div class="avocadoToggle">
              <ion-toggle mode="md" [ngModel]="showAvocadoClubIndicator" (ngModelChange)="setShowAvocadoClubIndicator()"
                disabled="{{!userIsPremium}}"></ion-toggle>
            </div>
          </div>

          <div *ngIf="!userData?.userValidated" [ngStyle]="(!userIsPremium ? {'cursor': 'pointer'} : null)"
            (click)="openValidation()" class="avocadoButton">

            <div class="avocadoText">
              <img class="avocado" src="assets/imgs/new-check-img.svg">
              {{'validateProfile' | translate}}
            </div>

            <div class="categoryArrow">
              <ion-icon src="/assets/imgs/custom-svg/Icon akar-arrow-left.svg"></ion-icon>
            </div>

          </div>


          <div *ngIf="userData?.userValidated" [ngStyle]="(!userIsPremium ? {'cursor': 'pointer'} : null)"
            (click)="openValidation()" class="avocadoButton">

            <div class="avocadoText">
              <img class="avocado" src="assets/imgs/new-check-img.svg">
              {{'validatedProfile' | translate}}
            </div>

            <div class="categoryArrow">
              <ion-icon src="/assets/imgs/custom-svg/Icon akar-arrow-left.svg"></ion-icon>
            </div>

          </div>

          <!--Green Buttons-->
          <div class="essentialMyInfoButtons">

            <span class="infoCategoryText">{{'myInfo' | translate}}</span>

            <!-- Diet -->
            <!-- <app-info-button (click)="setPageInfo('diet')" [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/diet.svg'" [tittle]="'dietLifestyle' | translate" [info]="userData !== null ? (userData?.diet | translate) : ''" [fill] = "'solid'"></app-info-button> -->

            <!--Gender-->

            <app-info-button (click)="setPageInfo('gender')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/gender.svg'" [tittle]="'gender' | translate"
              [info]="(userData?.gender2 !== null ? getGenderDisplayText(userData?.gender2) : '') +
            (userData?.gender2 === 'other' && userData?.genderdescription ? ' - ' + userData?.genderdescription : '')"
              [fill]="'solid'"></app-info-button>

            <!-- Interese-->

            <app-info-button (click)="setPageInfo('interest')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/heart.svg'" [tittle]="'interestedIn' | translate"
              [info]="userData !== null ? interestOptions() : ''" [fill]="'solid'"></app-info-button>

            <!-- Name-->

            <app-info-button (click)="setPageInfo('name')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/name.svg'" [tittle]="'name' | translate"
              [info]="userData !== null ? userData?.firstName : ''" [fill]="'solid'"></app-info-button>

            <!--Age-->

            <app-info-button (click)="setPageInfo('age')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/age.svg'" [tittle]="'age' | translate"
              [info]="userData !== null ? userData?.age : ''" [fill]="'solid'"></app-info-button>

            <!---City-->

            <app-info-button (click)="setPageInfo('city')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/location.svg'" [tittle]="'city' | translate"
              [info]="userData !== null ? userData?.city : ''" [fill]="'solid'"></app-info-button>

          </div>

          <div class="socialCausesContainer">
            <span class="socialCausesLabel">{{'socialCauses' | translate}}</span>
            <ion-item class="socialCausesItem" (click)="setPageInfo('socialCauses')">
              <div class="socialCausesContent">
                <div class="socialCausesValue">
                  <div *ngFor="let cause of userData?.socialCauses" class="socialCauseCard">
                    {{getSocialCauseDisplayText(cause)}}
                  </div>
                </div>
                <div class="categoryArrow">
                  <ion-icon src="/assets/imgs/custom-svg/Icon akar-arrow-left.svg"></ion-icon>
                </div>
              </div>
            </ion-item>
          </div>


          <div class="extraMyInfoButtons">
            <span class="infoCategoryText">{{'moreDetails' | translate}}</span>



            <!-- Activism-->

            <app-info-button (click)="setPageInfo('activism')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/activism.svg'" [tittle]="'activism' | translate"
              [info]="userData && userData?.activism !== null ? (userData?.activism | translate) : ''"
              [fill]="'outline'"></app-info-button>

            <!--Work-->

            <app-info-button (click)="setPageInfo('work')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/work.svg'" [tittle]="'workTitle' | translate"
              [info]="userData && userData?.work !== null ? userData?.work : ''" [fill]="'outline'"></app-info-button>

            <!--Education-->

            <app-info-button (click)="setPageInfo('education')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/education.svg'" [tittle]="'education' | translate"
              [info]="userData && userData?.education !== null ? (userData?.education | translate) : ''"
              [fill]="'outline'"></app-info-button>

            <!---Height-->

            <app-info-button (click)="setPageInfo('height')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/height.svg'" [tittle]="'height' | translate"
              [info]="userData !== null && userData?.height !== null ? setHeight() : ''"
              [fill]="'outline'"></app-info-button>

            <!---Physical Exercise-->

            <app-info-button (click)="setPageInfo('exercise')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/physicalExercise.svg'"
              [tittle]="'physicalExercise' | translate"
              [info]="userData && userData?.exercise !== null ? (userData?.exercise | translate) : ''"
              [fill]="'outline'"></app-info-button>

            <!---Looking For-->

            <app-info-button (click)="setPageInfo('lookingFor')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/lookingFor.svg'" [tittle]="'lookingFor' | translate"
              [info]="userData && userData?.lookingFor !== null ? lookingForOptions() : ''"
              [fill]="'outline'"></app-info-button>

            <!---Children-->

            <app-info-button (click)="setPageInfo('children')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/children.svg'" [tittle]="'children' | translate"
              [info]="userData && userData?.children !== null ? (userData?.children | translate) : ''"
              [fill]="'outline'"></app-info-button>

            <!---Astrology Sign-->

            <app-info-button (click)="setPageInfo('astroSign')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/astrology.svg'"
              [tittle]="'astrologySign' | translate" [info]="userData !== null ? userData?.astrologySign : ''"
              [fill]="'outline'"></app-info-button>

            <!---Religion-->

            <app-info-button (click)="setPageInfo('religion')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/religion.svg'" [tittle]="'religion' | translate"
              [info]="userData !== null ? userData?.religion : ''" [fill]="'outline'"></app-info-button>

            <!---Politics-->

            <app-info-button (click)="setPageInfo('politics')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/politics.svg'" [tittle]="'politics' | translate"
              [info]="userData !== null ? userData?.politics : ''" [fill]="'outline'"></app-info-button>

            <!---Animals-->

            <app-info-button (click)="setPageInfo('pets')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/animal_new.svg'" [tittle]="'animals' | translate"
              [info]="userData !== null ? userData?.pets : ''" [fill]="'outline'"></app-info-button>

          </div>


          <!--Grey Buttons-->
          <div class="distanceUnitButton">

            <!--Distance Units-->

            <app-info-button (click)="setPageInfo('distanceUnits')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/distance.svg'"
              [tittle]="'distanceUnits' | translate"
              [info]="userData && userData?.distanceUnit !== null ? (userData?.distanceUnit | translate) : ''"
              [fill]="'gray'"></app-info-button>

            <!--Language-->

            <app-info-button (click)="setPageInfo('language')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/language.svg'" [tittle]="'language' | translate"
              [info]="userData && userData?.language !== null ? (userData?.language | translate) : ''"
              [fill]="'gray'"></app-info-button>



            <div *ngIf="this.userData?.interest2!==null" class="save-button">
              <ion-button shape="round" expand="full" color="primary" (click)="backPage()" block>{{'save' |
                translate}}</ion-button>
            </div>

          </div>

        </div>

      </div>
    </div>
  </div>


</ion-content>
<ion-footer [class.editor-cheio]="showCropper">
  <ion-grid class="box-crop-options" *ngIf="showCropper">
    <!-- FOLHA da ferramenta. Fecha com Cancelar (que RESTAURA o filtro, os ajustes e o
         recorte por snapshot) ou Concluir (que mantem). O Instagram nao restaura; aqui
         restaura, que e o que permite experimentar sem medo. -->
    <div class="sheet" *ngIf="folhaAberta">
      <span class="sheet__handle"></span>

      <!-- Recortar -->
      <div class="sheet__body" *ngIf="folhaAberta === 'recortar'">
        <div class="croprow">
          <button type="button" class="tool" (click)="rotateCcw()" [attr.aria-label]="'cropRotateLeft' | translate">⟲</button>
          <button type="button" class="tool" (click)="rotate()" [attr.aria-label]="'cropRotateRight' | translate">⟳</button>
          <button type="button" class="tool" (click)="scaleX()" [attr.aria-label]="'cropMirror' | translate">⇄</button>
        </div>
        <div class="sld"><label>{{ 'cropZoom' | translate }}</label><input type="range" min="1" max="2.4" step="0.02" [value]="zoomVal" (input)="onZoom($event)"></div>
        <div class="sld"><label>{{ 'cropStraighten' | translate }}</label><input type="range" min="-20" max="20" step="1" [value]="straightenVal" (input)="onStraighten($event)"></div>
      </div>

      <!-- Ajustar: um circulo por parametro e UM slider, o do escolhido. Os 4 sliders de uma
           vez eram a razao de o painel antigo precisar de 118px congelados. -->
      <div class="sheet__body" *ngIf="folhaAberta === 'ajustar'">
        <div class="adjrow">
          <button type="button" class="adjdot" *ngFor="let a of ajustes"
            [class.on]="ajusteAtivo === a.chave" (click)="ajusteAtivo = a.chave">
            <i>{{ a.labelKey | translate }}</i>
            <ion-icon [name]="a.icone"></ion-icon>
          </button>
        </div>
        <div class="sld sld--solo" *ngIf="ajusteAtivo">
          <input type="range" [min]="faixaDoAjusteAtivo.min" [max]="faixaDoAjusteAtivo.max"
            [step]="faixaDoAjusteAtivo.passo" [value]="faixaDoAjusteAtivo.valor"
            (input)="onAdjust(ajusteAtivo, $event)">
        </div>
      </div>

      <!-- Filtros: miniaturas grandes com a FOTO REAL e o nome ACIMA, como no Instagram. -->
      <div class="sheet__body" *ngIf="folhaAberta === 'filtros'">
        <div class="fstrip">
          <button type="button" class="fthumb" *ngFor="let f of filterPresets"
            [class.sel]="activeFilter === f.css" (click)="applyFilter(f.css)">
            <i>{{ f.labelKey | translate }}</i>
            <span [style.filter]="f.css !== 'none' ? f.css : null">
              <img [src]="myImage" alt="" draggable="false">
            </span>
          </button>
        </div>
      </div>

      <div class="sheet__bar">
        <button type="button" class="sheet__act" (click)="cancelarFolha()">{{ 'cancel' | translate }}</button>
        <span class="sheet__title">{{ (folhaAberta === 'recortar' ? 'cropTabCrop' : folhaAberta === 'ajustar' ? 'cropTabAdjust' : 'cropTabFilters') | translate }}</span>
        <button type="button" class="sheet__act sheet__act--ok" (click)="concluirFolha()">{{ 'cropDone' | translate }}</button>
      </div>
    </div>

    <!-- FILA DE FERRAMENTAS, visivel quando nenhuma folha esta aberta. -->
    <div class="toolbar" *ngIf="!folhaAberta">
      <button type="button" class="toolbar__item" (click)="abrirFolha('recortar')">
        <ion-icon name="crop-outline"></ion-icon>
        <i>{{ 'cropTabCrop' | translate }}</i>
      </button>
      <button type="button" class="toolbar__item" (click)="abrirFolha('ajustar')">
        <ion-icon name="options-outline"></ion-icon>
        <i>{{ 'cropTabAdjust' | translate }}</i>
      </button>
      <button type="button" class="toolbar__item" (click)="abrirFolha('filtros')">
        <ion-icon name="color-filter-outline"></ion-icon>
        <i>{{ 'cropTabFilters' | translate }}</i>
      </button>
    </div>

    <!-- Tira das fotos escolhidas nesta leva, entre as abas e os botões de ação. Tocar numa
         delas abre aquela no crop. Só aparece com 2 ou mais: com uma, não há escolha. -->
    <div class="crop-tray" *ngIf="!folhaAberta && selecaoDeFotos.length > 1">
      <button type="button" class="crop-tray__item"
        *ngFor="let item of selecaoDeFotos; let i = index"
        [class.ativa]="i === editandoNaSelecao"
        (click)="editarDaSelecao(i)">
        <img [src]="item.thumb" alt="">
      </button>
    </div>

    <div class="crop-actions" *ngIf="!folhaAberta">
      <ion-button expand="full" shape="round" (click)="reset()" fill="outline">{{'cropOriginal' | translate}}</ion-button>
      <ion-button expand="full" shape="round" (click)="salvarTudo()">{{'save' | translate}}</ion-button>
    </div>
  </ion-grid>
</ion-footer>
